import { CombinedCollectionSettings, IDPConnection } from '../types';
import {
  HIDDEN_CONNECTION_APPDEFIDS,
  PASSWORD_CONNECTION_APPDEFID,
  IDP_APPDEFIDS,
} from '../../constants';

interface UseConnectionsSettingsParams {
  isEditor: boolean;
  settings: CombinedCollectionSettings;
}

interface ConnectionsSettings {
  socialConnections: IDPConnection[];
  hasPasswordConnection: boolean;
  ssoMandatory: boolean;
}

export const useConnectionSettings = ({
  settings,
}: UseConnectionsSettingsParams): ConnectionsSettings => {
  return enabledConnectionsToSettings(settings);
};

function enabledConnectionsToSettings(
  settings: CombinedCollectionSettings,
): ConnectionsSettings {
  const socialConnections =
    settings.enabledConnections?.filter(
      (conn) => !HIDDEN_CONNECTION_APPDEFIDS.has(conn.appDefId),
    ) || [];

  const hasPasswordConnection =
    settings.enabledConnections?.some(
      (conn) => conn.appDefId === PASSWORD_CONNECTION_APPDEFID,
    ) || false;

  const ssoMandatory =
    socialConnections.length === 1 &&
    socialConnections[0].appDefId === IDP_APPDEFIDS.sso &&
    !hasPasswordConnection;

  return {
    socialConnections,
    hasPasswordConnection,
    ssoMandatory,
  };
}
